import DataRoomDocumentsRouter from './DataRoomDocumentsRouter.component';

export default DataRoomDocumentsRouter;